'use strict';

/**
 * General http service using resource to reduce boilerplate code
 */
module.exports = (app) => app.factory(
    'httpService', /* @ngInject */
    /**
     * @param $resource
     * @return {
     *      {
     *          request: (function(*, *, *, *=): Promise<unknown>),
     *          post: (function(*, *, *=): Promise<unknown>),
     *          methods: {DELETE: string, POST: string, GET: string, PUT: string},
     *          get: (function(*, *=): Promise<*>),
     *          delete: (function(*, *=): Promise<*>)
     *      }
     *  }
     */
    function ($resource) {

        /**
         * @type {{DELETE: string, POST: string, GET: string, PUT: string}}
         */
        const METHODS = {
            GET: 'get',
            POST: 'save',
            PUT: 'put',
            DELETE: 'delete'
        }

        /**
         * Perform a http request
         * @param method
         * @param url
         * @param options
         * @param body
         * @return {Promise<unknown>}
         */
        function fetch(method, url, options, body = null) {
            return new Promise((resolve, reject) => {
                $resource(url, body, {
                    [method]: {
                        method,
                        ...options
                    },
                })[method]().$promise.then((data) => {
                    resolve(data)
                }, reject);
            })
        }

        function post(url, body = {}, options = {}) {
            return new Promise((resolve, reject) => {
                const resource = $resource(url, {}, {
                    'save': {
                        method: 'POST',
                        ...options
                    },
                });
                resource.save(body).$promise.then((data) => {
                    resolve(data)
                }, reject);
            })
        }

        function put(url, body = {}, options = {}) {
            return new Promise((resolve, reject) => {
                const resource = $resource(url, {}, {
                    'save': {
                        method: 'PUT',
                        ...options
                    },
                });
                resource.save(body).$promise.then((data) => {
                    resolve(data)
                }, reject);
            })
        }

        return {
            /**
             * Perform a GET request
             * @param url
             * @param options
             * @return {Promise<unknown>}
             */
            get: (url, options = {}) => fetch(METHODS.GET, url, options),
            /**
             * Perform a POST request
             * @param url
             * @param body
             * @param options
             * @return {Promise<unknown>}
             */
            post: (url, body, options = {}) => post(url, body, options),
            /**
             * Perform a POST request
             * @param url
             * @param body
             * @param options
             * @return {Promise<unknown>}
             */
            put: (url, body, options = {}) => put(url, body, options),
            /**
             * Perform a DELETE request
             * @param url
             * @param options
             * @return {Promise<unknown>}
             */
            delete: (url, options = {}) => fetch(METHODS.DELETE, url, options),
            /**
             * Perform a custom request
             * @return {Promise<unknown>}
             */
            request: fetch,

            /**
             * Supported http methods
             * @return {{DELETE: string, POST: string, GET: string, PUT: string}}
             */
            methods: METHODS
        }
    })
